module.exports = __webpack_public_path__ + "static/img/prize-2.53959689.png";